import { Suspense } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import {
    themeZbdsBase,
    themeZbdsLight,
    themeZbdsDark,
    themeZbdsTranslucent,
    registerTheme,
    registerTypefaces,
    setAppTheme,
} from '@zeiss/zui-themes'
import { toast as toastConfig } from 'app/config'
import {
    useAuth,
    useAppInitialize,
    useSignalR,
    useRefreshToken,
    useRtkListener,
    useIdleTimer,
} from 'hooks'
import { Loader } from 'components/Loaders'
import FullscreenLayout from 'components/Layout/Fullscreen'
import DefaultLayout from 'components/Layout/Default'
import PrivateRoute from 'components/PrivateRoute'
import PageNotFound from 'components/PageNotFound'
import SurgicalCloud from 'pages/SurgicalCloud'
import Dashboard from 'pages/Dashboard'
import Development from 'pages/Development'
import Form from 'features/form'
import FileView from 'features/file-view'
import '@zeiss/zui'
import '@zeiss/zui-icons'
import './App.css'

registerTheme(themeZbdsBase)
registerTheme(themeZbdsLight)
registerTheme(themeZbdsDark)
registerTheme(themeZbdsTranslucent)
setAppTheme('zbds-light')
registerTypefaces('/fonts')

function App() {
    const { isAuthenticated, isAuthenticating } = useAuth()
    const { pause, reset } = useIdleTimer()

    useAppInitialize()
    useSignalR()
    useRefreshToken()
    useRtkListener()

    if (isAuthenticated === null) {
        return isAuthenticating ? <Loader /> : null
    }

    const loading = () =>
        isAuthenticated && (
            <DefaultLayout>
                <div>Loading...</div>
            </DefaultLayout>
        )

    return (
        <BrowserRouter>
            <Suspense fallback={loading()}>
                <ToastContainer {...toastConfig} />
                <div className="App">
                    <Switch>
                        <PrivateRoute>
                            <Route exact path={['/', '/surgical-cloud', '/form', '/dev']}>
                                <DefaultLayout>
                                    <Route exact path="/" component={Dashboard} />
                                    <Route exact path="/surgical-cloud" component={SurgicalCloud} />
                                    <Route exact path="/form" component={Form} />
                                    <Route exact path="/dev" component={Development} />
                                </DefaultLayout>
                            </Route>
                            <Route exact path={['/files/:id']}>
                                <FullscreenLayout>
                                    <Route
                                        path="/files/:id"
                                        render={() => (
                                            <FileView pauseTimer={pause} resetTimer={reset} />
                                        )}
                                    />
                                </FullscreenLayout>
                            </Route>
                        </PrivateRoute>
                        <Route component={PageNotFound} />
                    </Switch>
                </div>
            </Suspense>
        </BrowserRouter>
    )
}

export default App
